module.exports = __webpack_public_path__ + "img/i-badges-admin.4801e5bb.svg";